import React from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import Header from '../pages/Header';
import Footer from '../pages/Footer';
import Home from '../pages/Home';

require('../assets/favicon.ico');

const App = () => (
  <div>
    <Header />
    <Router>
      <div className="raam-main">
        <div className="container">
          <Switch>
            <Route exact path="/" component={Home} />
          </Switch>
        </div>
      </div>
    </Router>
    <Footer />
  </div>
);

export default App;
